import { useNavigate } from "react-router-dom";

import { pathGenerators } from "utils/routes";

export const useOpenPatientSummaryPage = () => {
  const navigate = useNavigate();

  return async (patientId) => {
    if (!patientId) return;

    navigate(pathGenerators.patient.consult(patientId));
  };
};
